var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyreply-chat-icon",class:[
    'keyreply-chat-icon',
    `keyreply-chat-icon--${_vm.app.id}`,
    { 'keyreply-panel': _vm.panel },
    { 'keyreply-chat-icon--custom-bg': _vm.app.background },
    { 'keyreply-chat-icon--custom-font': _vm.app.fontColor },
  ],attrs:{"data-position-index":_vm.index},on:{"click":_vm.activate}},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.app.id}}),_c('div',{staticClass:"keyreply-label"},[_vm._v(" "+_vm._s(_vm._f("capitalize")((_vm.app.title || _vm.app.id)))+" ")]),_c('div',{staticClass:"keyreply-qr"},[_c('img',{staticClass:"w-full h-full",attrs:{"src":_vm.mobileUrlSrc,"alt":_vm.app.id}})]),_c('a',{ref:"link",staticClass:"hidden",attrs:{"href":_vm.href,"target":"_blank"}}),(_vm.app.id === 'facebook')?_c('facebook',{attrs:{"facebook":_vm.app}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }